import { render } from "./BasketIndex.vue?vue&type=template&id=29893b7a&scoped=true"
import script from "./BasketIndex.vue?vue&type=script&lang=js"
export * from "./BasketIndex.vue?vue&type=script&lang=js"

import "./BasketIndex.vue?vue&type=style&index=0&id=29893b7a&lang=scss&scoped=true"

import exportComponent from "/Users/marc.bush/Sites/ensotyres/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-29893b7a"]])

export default __exports__